import { HeaderContent } from "./HeaderContent";

import { OverflowDisplayTooltip } from "@/components/ui/Tooltip/OverflowDisplayTooltip";
import { ColumnType, ReportColumn } from "@/types/evaluate";
import { cn } from "@/lib/utils";

interface HeaderLabelProps {
  column: ReportColumn;
}

export const HeaderLabel = ({ column }: HeaderLabelProps) => {
  const isDraft = !column.id || column.id === -999;
  const isDatasetColumn = column.column_type === ColumnType.DATASET;

  if (isDatasetColumn) {
    return (
      <div className="group relative m-auto flex h-full w-full min-w-0 flex-shrink items-center justify-center px-3 py-2">
        <OverflowDisplayTooltip content={`{${column.name}}`}>
          <span className="truncate px-2 text-center">{`{${column.name}}`}</span>
        </OverflowDisplayTooltip>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "group relative m-auto flex h-full min-w-0 flex-shrink items-center justify-center px-3 py-2",
        isDraft && "text-gray-400",
      )}
    >
      <OverflowDisplayTooltip content={column.name}>
        <span className="flex-inline relative h-full w-full cursor-pointer items-center pl-6">
          <HeaderContent column={column} />
        </span>
      </OverflowDisplayTooltip>
    </div>
  );
};
